<template>
    <div class="table-filters-container">
        <div class="custom-filters" v-if="queryFilter">
            <div class="custom-filters-item" v-for="(QFField, QFIndex) in queryFilter" v-bind:key="QFIndex">
                <span>{{getUnnamedFilter(QFField)}}</span>
            </div>
        </div>
        <div class="table-filters">
            <div class="table-filter-wrapper">
                <span class="icon-clear" @click="clearFilter()" title="Clear filters">
                  <i class="fa fa-solid fa-trash" style="font-size: 17px"></i>
                </span>
                <span class="input-wrapper" v-for="(filterField, filterIndex) in filter" v-bind:key="filterField.name">
                          <label v-if="filterField.realName">{{ filterField.realName }}:</label>
                          <label v-else>{{ filterField.name }}:</label>
                          <b-form-input
                                  v-if="filterField.type === 'input' || filterField.type === '' || filterField.type === undefined"
                                  v-model="filterValues[filter[filterIndex].name]"
                                  :placeholder="filterField.name"
                                  :style="{width: filterField.w + 'px'}"
                                  @update="filterChanged()"></b-form-input>
                          <b-form-select
                                  v-if="filterField.type === 'select'"
                                  v-model="filterValues[filter[filterIndex].name]"
                                  :options="filterField.options"
                                  :style="{width: filterField.w + 'px'}"
                                  @change="filterChanged()"></b-form-select>
                          <button
                                  v-if="filterField.type === 'button'"
                                  @click="buttonFilter(filterField.filter)"
                                  class="btn btn-primary btn-filter"
                                  :class="{'implemented':buttonCheck(filterField.filter)}"
                          >{{filterField.value}}</button>
                      </span>
            </div>
        </div>
    </div>
</template>
<script>
    function debounce(that, fn, delay) {
        let timeoutID = undefined;
        return () => {
            clearTimeout(timeoutID);
            const args = arguments;
            timeoutID = setTimeout(() => {
                fn.apply(that, args);
            }, delay);
        };
    }

    export default {
        name: 'listFilters',
        props: { 
            result: Array,
            filter: {
                type: Array,
                default: function () {
                    return {
                        name: 'Name',
                        value: '',
                        w: 100
                    }
                }
            },
            filterValues: {
                type: Object,
                default: function () {
                    return {
                        Name: '',
                    }
                }
            }
        },
        data() {
            return {
                filters: [],
                queryFilter: [],
            };
        },
        methods: {
            onRouteChange() {
                this.queryFilter = [];
                this.filters = [];
                this.filterQuery();
                this.$emit('onInit', this.filters);
            },
            pushFilters(filterConfig) {
                for (let filterIdx in filterConfig) {
                    if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
                        continue;
                    }
                    let field;
                    let value;
                    for (let fieldName in filterConfig[filterIdx].Data) {
                        field = fieldName;
                        value = filterConfig[filterIdx].Data[fieldName];
                    }
                    if (value) {
                        this.filterValues[field] = value;
                    }
                }
            },
            popFilters(filterConfig) {
                let filterCopy = [];
                for (let filterIdx in filterConfig) {
                    let data = {};
                    if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
                        return true;
                    }
                    let field;
                    let value;
                    for (let fieldName in filterConfig[filterIdx].Data) {
                        field = fieldName;
                        value = filterConfig[filterIdx].Data[fieldName];
                    }
                    if (Object.keys(this.filterValues).includes(field)) {
                        this.filterValues[field] = '';
                    }
                    data[field] = value;
                    let filterExist = false;
                    let lastFilterItem = {};
                    for (let filterUsedIdx in this.filters) {
                        let fieldUsed;
                        let valueUsed;
                        if (!this.filters[filterUsedIdx]) continue;
                        if (this.filters[filterUsedIdx] == undefined) {console.log("WTF");}
                        for (let fieldName in this.filters[filterUsedIdx].Data) {
                            fieldUsed = fieldName;
                            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
                        }
                        if (this.filters[filterUsedIdx].Condition !== filterConfig[filterIdx].Condition &&
                            fieldUsed != field && value != valueUsed) {
                            filterExist = true;
                            lastFilterItem = this.filters[filterUsedIdx];
                        }
                    }
                    if (filterExist) {
                        filterCopy.push(lastFilterItem);
                        this.filterValues[field] = value;
                    }
                }
                this.filters = filterCopy;
            },
            buttonFilter(filterConfig) {
                if (Object.keys(filterConfig || {}).length === 0) {
                    return
                }
                if (!this.buttonCheck(filterConfig)) {
                    this.pushFilters(filterConfig);
                } else {
                    this.popFilters(filterConfig);
                }
                this.filterSend();
            },
            buttonCheck(filterConfig) {
                let keyCount = Object.keys(filterConfig || {}).length
                if (keyCount === 0) {
                    return true;
                }
                let keyAlignmentCount = 0;
                for (let filterIdx in filterConfig) {
                    let data = {};
                    if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
                        return true;
                    }
                    let field;
                    let value;
                    for (let fieldName in filterConfig[filterIdx].Data) {
                        field = fieldName;
                        value = filterConfig[filterIdx].Data[fieldName];
                    }
                    data[field] = value;

                    for (let filterUsedIdx in this.filters) {
                        let fieldUsed;
                        let valueUsed;
                        if (!this.filters[filterUsedIdx]) continue;
                        if (this.filters[filterUsedIdx] == undefined) {console.log("WTF");}
                        for (let fieldName in this.filters[filterUsedIdx].Data) {
                            fieldUsed = fieldName;
                            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
                        }
                        if (this.filters[filterUsedIdx].Condition === filterConfig[filterIdx].Condition &&
                            fieldUsed == field && value == valueUsed) {
                            keyAlignmentCount++;
                        }
                    }
                }
                if (keyCount === keyAlignmentCount) {
                    return true;
                }
                return false;
            },
            filterChanged() {
                this.debounced();
            },
            clearFilter() {
                for (let FieldName in this.filterValues) {
                    this.filterValues[FieldName] = '';
                }
                this.filters = [];
                this.queryFilter = [];
                this.$route.query.filter;
                this.filterChanged();
            },
            filterSend() {
                let currentQuery = this.$route.query;
                let newFilters = [];
                for (let FieldName in this.filterValues) {
                    if (this.filterValues[FieldName] != '') {
                        let data = {};
                        data[FieldName] = this.filterValues[FieldName];
                        newFilters.push({
                            Condition: "ilike",
                            Data: data,
                        });
                    }
                }
                if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(newFilters)})) {
                    this.$router.push({query: {filter: JSON.stringify(newFilters)}});
                } else {
                    console.log('Filter error: filter duplicate')
                }
                //this.$emit('onChanged', this.filters);
            },
            actualFilter() {
                return this.filters
            },
            filterQuery() {
                if (!this.$route.query.filter) {
                    return;
                }
                this.queryFilter = JSON.parse(this.$route.query.filter);
                if (this.queryFilter.length == 0) {
                    return;
                }
                if (this.queryFilter) {
                    if (Object.keys(this.queryFilter || {}).length === 0) {
                        for (let FieldName in this.filterValues) {
                            this.filterValues[FieldName] = '';
                        }
                    }
                    for (let filterIdx in this.queryFilter) {
                        let data = {};
                        if (!this.queryFilter[filterIdx].Data || !this.queryFilter[filterIdx].Condition) {
                            continue;
                        }
                        let condition = this.queryFilter[filterIdx].Condition;
                        let field;
                        let value;
                        for (let fieldName in this.queryFilter[filterIdx].Data) {
                            field = fieldName;
                            value = this.queryFilter[filterIdx].Data[fieldName];
                        }
                        if (value !== null && value !== undefined) {
                            this.filterValues[field] = value;
                        }
                        data[field] = value;
                        this.filters.push({
                            Condition: condition,
                            Data: data,
                        });
                    }
                }
            },
            getUnnamedFilter(data) {
                let condition;
                let field;
                let value;
                if (Object.prototype.hasOwnProperty.call(data, 'Data') &&
                    Object.prototype.hasOwnProperty.call(data, 'Condition')) {
                    condition = data['Condition'];
                    field = Object.keys(data['Data'])[0];
                    value = data['Data'][field];
                }
                let fieldExist = false;
                for (let filterIndex in this.filter) {
                    if (Object.prototype.hasOwnProperty.call(this.filter[filterIndex], 'name')) {
                        if (field == this.filter[filterIndex].name) {
                            fieldExist = true;
                        }
                    }
                }
                if (!fieldExist) {
                    return field +  ' ' + condition + ' ' + value;
                }
                return '';
            },
        },
        watch: {
            '$route': 'onRouteChange'
        },
        created: function () {
            this.filterQuery();
            this.$emit('onInit', this.filters);
            this.debounced = debounce(this, this.filterSend, 1200);
        }
    }
</script>
